import { frontendURL } from '../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions';

const Calendar = () => import('./Calendar.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/calendar'),
      name: 'calendar_index',
      meta: { permissions: ROLES },
      component: Calendar,
    },
  ],
};
